module.exports = __webpack_public_path__ + "static/media/Banner-Supermee.b63b25e4.png";